import React from "react";
import Main from "../components/Main";
import SlopeChartWealth from "../components/SlopeChartWealth";
import { wealthMillennials, wealthParents } from "../data/chartData";

export default class extends React.Component {
  render() {
    return (
      <div>
        <Main>
          <SlopeChartWealth
            dataMillennials={wealthMillennials}
            dataParents={wealthParents}
            width={this.props.width}
          />
        </Main>

        <style jsx global>{`
          html, body {
            height: 100%
          }

          body {
            background: #fff;
            margin: 0;
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-font-smoothing: grayscale;
          }
        `}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/slope-wealth.js